import { Switch } from '@headlessui/react';
import cn from '@/lib/clsxm';
import Toggle from '@/components/@base/input/check-box/toggle';
import Props from '@/components/@base/input/check-box/type';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import FontIcon from '@/components/@base/font-icon';
export default function CheckBox({ onChange, checked = false, className, text, isDisable }: Props) {
  return (
    <Switch checked={checked} onChange={onChange}>
      <Container className={cn(text && 'flex items-center gap-2.5')}>
        <Container
          className={cn(
            'flex h-5 w-5 items-center justify-center rounded border-[1px] border-black dark:border-white',
            checked && 'border-none bg-black dark:bg-white',
            isDisable && "border-grayLight-25 dark:border-grayLight-750",
            className,
          )}
        >
          <FontIcon icon="icon-check-bold" className={cn('text-white dark:text-black text-xl', !checked && 'opacity-0')}/>
         </Container>
        {text && <Text bold>{text}</Text>}
      </Container>
    </Switch>
  );
}

export { Toggle };
